import CrudPage from "../../Components/CrudPage"
import React, { useState, useEffect } from "react";
import { useModal } from "../../Components/Modal"
import AdminController from "../../APIController/AdminController"
import Text from "../../Components/Text";
import WorkspaceManagement from "./WorkspaceManagement";

const AllWorkspaceManagement = () => {
    const [workspaces, setWorkspaces] = useState([])
    const { ModalView, openModal, closeModal } = useModal()
    const { getAllWorkspaces } = AdminController()

    useEffect(() => {
        fetchWorkspaces()
    }, [])

    const fetchWorkspaces = async () => {
        const data = await getAllWorkspaces()
        setWorkspaces(data)
    }

    const editClick = async(e, item) => {
       openModal(<WorkspaceManagement workspace={item} afterAction={() => afterSubmit()} />)
    }

    const afterSubmit = () =>{
        fetchWorkspaces()
        closeModal()
    }

    return (
        <>
            <CrudPage
                title={"Workspaces"}
                items={workspaces}
                displayMethod={(item) => (
                    <>
                        <Text type="itemmain">{item.name}</Text>
                        <Text type="itemmain">{item.workspaceStatus}</Text>
                    </>
                )}
                crudActions={[
                    { type: "edit", color: "bg-lime-500", action: editClick, icon: "pencil.svg" }
                ]}
                isAdminPage={true}
            />
            <ModalView classNames="w-auto" />
        </>
    )
}
export default AllWorkspaceManagement